import { Stack } from "@mui/material";
import SelectControl from "components/form/SelectControl";
import SwitchControl from "components/form/SwitchControl";
import { useFormContext } from "react-hook-form";
import { ReminderInputs } from "../types";

const REMINDER_SCHEDULE_OPTIONS = [
  {
    label: "1 день",
    value: 1,
  },
  {
    label: "3 дня",
    value: 3,
  },
  {
    label: "7 дней",
    value: 7,
  },
];

interface ReminderSwitchProps {
  isEditing: boolean;
}

const ReminderSwitch = ({ isEditing }: ReminderSwitchProps) => {
  const form = useFormContext<ReminderInputs>();
  const sendReminder = form.watch("sendReminder");

  return (
    <Stack
      spacing={1}
      useFlexGap>
      <SwitchControl
        disabled={!isEditing}
        name='sendReminder'
        label='Напоминания'
        tooltipTitle='Напоминать кандидатам о предстоящем тестировании'
      />
      {sendReminder && (
        <SelectControl
          disabled={!isEditing}
          items={REMINDER_SCHEDULE_OPTIONS}
          name='reminderSchedule'
          label='Частота напоминаний'
          rules={{ required: sendReminder }}
          sx={{
            backgroundColor: "bgSwitch",
          }}
        />
      )}
    </Stack>
  );
};

export default ReminderSwitch;
